.modal_container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // Fondo oscuro semi-transparente
}

.modal_text {
  margin-bottom: 16px !important;
}

.modal_actions {
  margin-top: 16px;
}
